module.exports = __webpack_public_path__ + "img/Group 6854@2x.104730ce.png";